import React from "react";
import { MessageTypeEnum, RoleEnum } from "../../types/chat";
// import ChatSuggestCard from "./ChatSuggestCard";
import ChatFileCard from "./ChatFileCard";
import { SmartToy } from "@mui/icons-material";
import { Box, Button } from "@mui/material";

type TProps = {
  role: RoleEnum | keyof typeof RoleEnum;
  message: string;
  messageType: MessageTypeEnum | keyof typeof MessageTypeEnum;
  hideIcon?: boolean;
  links?: [string];
};

export const ChatMessage = (props: TProps) => {
  const isHuman = props.role === RoleEnum.human;
  const bgColor = isHuman ? "bg-gray-200" : "bg-green-600";
  const textColor = isHuman ? "" : "text-white";

  const downloadLink = (url: string, filename: string) => {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.setAttribute("target", "_blank");
    a.click();
  };

  return (
    <div className={`py-2 flex`}>
      {!isHuman && (
        <div className={`${props.hideIcon ? "invisible" : ""} p-2`}>
          <SmartToy />
        </div>
      )}
      <div
        className={`${
          isHuman ? "items-end" : "items-start"
        } flex flex-col w-full`}
      >
        {props.messageType === MessageTypeEnum.video ? (
          <ChatFileCard src={props.message} type="video" filename="下載影片" />
        ) : (
          <div
            className={`p-2 rounded-2xl ${
              isHuman ? "rounded-tr-none " : "rounded-tl-none "
            } ${bgColor} ${textColor} break-all flex items-center shadow-md max-w-[80%]`}
          >
            {props.message}
            {props.messageType === MessageTypeEnum.loading && (
              <div className="flex min-h-[24px] items-center">
                {Array.from({ length: 3 }).map((_, index) => (
                  <div
                    key={index}
                    className={`w-[4px] h-[4px] rounded-full mx-1 ${
                      isHuman ? "bg-gray-600" : "bg-white"
                    } animate-opacity ${
                      index === 1
                        ? "animation-delay-100"
                        : index === 2
                        ? "animation-delay-200"
                        : ""
                    }`}
                  />
                ))}
              </div>
            )}
          </div>
        )}
        {/* {props.links &&
          [...new Set(props.links)].map((link, index) => (
            <Box className="mt-2" key={link + index}>
              <Button
                sx={{
                  textAlign: "left",
                }}
                variant="outlined"
                size="small"
                onClick={() =>
                  downloadLink(
                    link,
                    decodeURI(link.substring(link.lastIndexOf("/") + 1))
                  )
                }
              >
                {decodeURI(link.substring(link.lastIndexOf("/") + 1))}
              </Button>
            </Box>
          ))} */}
        {/*{!isHuman &&*/}
        {/*  props.messageType === MessageTypeEnum.loading &&*/}
        {/*  props.message === LoadingMessageEnum.video && (*/}
        {/*    <div className="w-full">*/}
        {/*      <ChatSuggestCard className="mt-2" />*/}
        {/*    </div>*/}
        {/*  )}*/}
      </div>
    </div>
  );
};

export default ChatMessage;
